import axiosServices from "../utils/axios";
import { convertToCamelCase, convertToSnakeCase } from "../utils/code-utils";

import type { DirectBilling } from "../utils/types/directBilling";

export const fetchDirectBillingList = async () => {
  const response = await axiosServices.get("/directbilling");
  const resData = await response.data;
  return convertToCamelCase<DirectBilling[]>(resData.data);
};

export const updateDirectBillingListData = async (
  id: string,
  data: {
    [key: string]: any;
  }
) => {
  const inputData = convertToSnakeCase(data);
  await axiosServices.put(`/directbilling/${id}`, inputData);
  return {
    success: true,
    data: {
      ...data,
      directBillingAssignmentId: id,
    },
  };
};

export const deleteDirectBillingListData = async (id: string) => {
  const response = await axiosServices.delete(`/directbilling/${id}`);
  return { success: response.data.success, id };
};

export const addDirectBillingListData = async (data: {
  [key: string]: any;
}) => {
  const inputData = convertToSnakeCase(data);
  const response = await axiosServices.post(`/directbilling`, inputData);
  return convertToCamelCase<DirectBilling>(response.data.data);
};
